<div class="image-slider" [ngClass]="{'container': !isMobile}">
  <div *ngIf="fundraiser?.beneficiary?.tax_benefit" class="tax_exempt">
    <div class="taxContainer" *ngIf="!isMobile || userData?.aggdonationall?.funds">
      <span class="taxRibbon" *ngIf="isMobile">
        <img loading="lazy" data-src="/assets/images/tax.svg" alt="Tax Benefit Ribbon" src="/assets/images/transparent.png">
      </span>
      <div class="tax-benefit" *ngIf="!isMobile">
        <div class="taxt-container">
          <img loading="lazy" data-src="/assets/images/tax.svg" alt="Tax benefit ribbon"/>
        </div>
      </div>
    </div>
    <span class="tooltipText">80G Tax Exemption Certificate Available</span>
  </div>
  <div class="days-left" [ngClass]="{'hide': !userData?.aggdonationall?.funds && isMobile }" *ngIf="fundraiser?.end_date && !isFundraiserEnded && !fundraiser?.settings?.hidedaysleft">
    <span>
      <i class="icon-stopwatch icomoon"></i>{{fundraiser?.end_date | dayjs:'diffInDays':1}} {{(fundraiser?.end_date | dayjs:'diffInDays':1) > 1 ? 'Days Left' : 'Day Left'}}
    </span>
  </div>
  <div *ngIf="fundraiser?.video_appeal" class="watch-appeal" [ngClass]="{'watch-appeal-pos': !fundraiser?.hospital?.info_1}">
    <button (click)="scrollToVideo()" mat-button><span><i class="material-icons">play_circle_filled</i>Watch Appeal</span></button>
  </div>
  <div *ngIf="fundraiser?.gallery?.length <= 1">
    <img loading="lazy" class="threatre-img" [attr.data-src]="getTheaterImage()" [default]="utilService.defaultImg" alt="{{fundraiser?.story_title?.info_1}}" [ngClass]="{'blur-image':(vwo.story_blur_image_ABC() ==='GLOBAL' && varService?.blur_image) || vwo.story_blur_image_ABC() ==='INDIVIDUAL' && varService?.blur_image}" />
    <!-- blur-btn -->
    <button *ngIf="vwo.story_blur_image_ABC() === 'INDIVIDUAL' && varService?.blur_image" class="blur-btn" (click)="toggleBlur()" mat-icon-button>
      <mat-icon>visibility</mat-icon>&nbsp;Show photos
    </button>
    <button *ngIf="vwo.story_blur_image_ABC() === 'INDIVIDUAL' && !varService?.blur_image" class="blur-btn" (click)="toggleBlur()" mat-icon-button>
      <mat-icon>visibility_off</mat-icon>&nbsp;Hide photos
    </button>
    <div class="banner-overlay">
      <div class="story-title-wrapper">
        <h3 *ngIf="fundraiser?.story_title" class="story_title" [innerHTML]="fundraiser?.story_title?.info_1 | safeHtml"></h3>
      </div>
    </div>
  </div>
  <div *ngIf="fundraiser?.gallery?.length > 1">
    <app-story-img-slider *ngIf="fundraiser" [fundraiser]="fundraiser" [gallery]="fundraiser?.gallery" [basicInfo]="fundraiser?.basicinfo" slideType="leaderboard" [shadow]="false"></app-story-img-slider>
  </div>
</div>
